const PHRASES = [
  "Atendimento digital em todo o Brasil",
  "Sigilo absoluto e proteção patrimonial",
  "Especialistas em divórcio de alta complexidade",
  "Otimização tributária ITCMD & Imposto de Renda",
  "TSS — Advogados · Naviraí/MS e Nacional",
];

export const Marquee = () => (
  <div
    data-testid="editorial-marquee"
    className="relative border-y border-amber-500/15 bg-[#0E1728] py-5 overflow-hidden"
  >
    <div className="animate-marquee flex whitespace-nowrap w-max">
      {[0, 1].map((copy) => (
        <div key={copy} className="flex items-center" aria-hidden={copy === 1}>
          {PHRASES.map((p, i) => (
            <span key={`${copy}-${i}`} className="flex items-center">
              <span className="font-display italic text-lg sm:text-xl text-slate-300/80 px-8">
                {p}
              </span>
              <span className="w-1.5 h-1.5 rotate-45 bg-amber-400/70 shrink-0" />
            </span>
          ))}
        </div>
      ))}
    </div>
    <div className="absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-[#0E1728] to-transparent pointer-events-none" />
    <div className="absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-[#0E1728] to-transparent pointer-events-none" />
  </div>
);
